import { RefObject } from 'react';
import { Category, Account } from '@/types';
import { handleStateFileUpload } from '@/utils/stateManagement';
import { toast } from "sonner";

interface FileHandlerProps {
  setCategories?: React.Dispatch<React.SetStateAction<Category[]>>;
  onSetAccounts: React.Dispatch<React.SetStateAction<Account[]>>;
  expanded: Set<string>;
  onToggle: (categoryId: string) => void;
  fileInputRef: RefObject<HTMLInputElement>;
}

export function FileHandler({
  setCategories,
  onSetAccounts,
  expanded,
  onToggle,
  fileInputRef,
}: FileHandlerProps) {
  const handleUploadState = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) {
      console.warn('No file selected');
      return;
    }

    if (!setCategories) {
      console.error('setCategories callback not provided');
      toast.error('Unable to restore state: missing callback');
      return;
    }

    try {
      await handleStateFileUpload(file, {
        setCategories,
        setAccounts: onSetAccounts,
        toggleCategory: onToggle,
        expanded
      });
      
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
    } catch (error) {
      console.error('Error handling state upload:', error);
    }
  };

  return (
    <input
      type="file"
      ref={fileInputRef}
      onChange={handleUploadState}
      accept=".glmt"
      className="hidden"
    />
  );
}